<template>
  <div
    :key="value"
    class="am-steps"
  >
    <div class="step">
      <div
        v-for="(step, idx) in steps"
        :key="idx"
        class="step__item"
      >
        <AmTypography
          :text="step.title"
          typography-style="l6"
        />
        <div
          ref="indicator"
          class="step__item__indicator"
        />
      </div>
    </div>

    <div
      ref="stepBar"
      class="step__bar"
    >
      <div
        ref="progress"
        :class="`step__bar__progress ${theme.color}`"
      />
    </div>

    <div class="step__content">
      <slot />
    </div>
    <slot name="footer" />
  </div>
</template>

<script>
/*
  TODO: remover esse import de mixin quando for migrar para componente do storybook
  TODO: O componente ainda precisa ser melhorado no seguinte ponto:
        Ao passar um valor para o v-model maior que 0, ele nao está fazendo o progresso e
        setando os indicadores ativos.
*/
import themeMixin from '@/components/mixins/themeMixin'

export default {
  name: 'AmSteps',
  mixins: [themeMixin],
  props: {
    steps: {
      type: Array,
      default: () => [],
    },
    currentStep: {
      type: Number,
      required: true,
    },
    value: {
      type: Number,
      default: () => 0,
    },
    hidePrevious: {
      type: Boolean,
      default: () => false,
    },
    disablePrevious: {
      type: Boolean,
      default: () => false,
    },
    hideNext: {
      type: Boolean,
      default: () => false,
    },
    disableNext: {
      type: Boolean,
      default: () => false,
    },
    previousActionLabel: {
      type: String,
      default: () => 'Anterior',
    },
    nextActionLabel: {
      type: String,
      default: () => 'Próximo',
    },
  },
  data() {
    return {
      keyUpdt: 0,
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        setTimeout(() => {
          this.setIndicatorActive()
          this.setProgress()
        }, 25)
      },
    },
  },
  mounted() {
    setTimeout(() => {
      this.setIndicatorActive()
      this.setProgress()
    }, 25)
  },
  methods: {
    previousStep() {
      this.$router.go(-1)
    },
    setProgress() {
      const FINAL_STEPS = -1
      this.keyUpdt += 1
      let progress = 0
      this.setIndicatorActive()

      const indicatorsActive = document.querySelectorAll(
        `div.step__item__indicator.${this.theme.color}`
      )
      const lastActiveIndicator = indicatorsActive.length - 1
      const indicatorsActiveRect = indicatorsActive[lastActiveIndicator].getBoundingClientRect()
      const stepBarRect = this.$refs.stepBar.getBoundingClientRect()
      const stepBarWidth = this.$refs.stepBar.clientWidth
      const offSet = indicatorsActiveRect.left - stepBarRect.left
      const indicatorWidth = indicatorsActive[lastActiveIndicator].clientWidth

      progress =
        this.currentStep === FINAL_STEPS ? 100 : ((offSet + indicatorWidth) / stepBarWidth) * 100

      this.$refs.progress.style.maxWidth = `${progress}%`
    },
    setIndicatorActive() {
      const indicators = this.$refs.indicator
      let currentStep = this.value >= 0 ? this.value : 2

      if (this.value === 2) {
        currentStep = 1
      }

      Array.from(indicators).forEach((indicator, i) => {
        if (i <= currentStep) {
          indicator.classList.add(`${this.theme.color}`)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.am-steps {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  justify-content: flex-start;
  @include mobile {
    max-height: calc(100vh - 70px - 120px);
  }

  @include tablet {
    justify-content: flex-end;
    height: unset;
  }
  .step {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    list-style-type: none;

    .step__item {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 0 0 25%;
      text-align: center;
      // TODO: ajustar para a barra para adaptar em todas as situacoes
      // background: red;
      // max-width: 15px;
      // word-wrap: normal;

      .step__item__indicator {
        width: 15px;
        height: 15px;
        background: $white !important;
        border: solid $dark-blue-20 3px;
        border-radius: 2em;
        z-index: 3;
      }

      .step__item__indicator--active {
        border: solid 3px;
      }
    }
  }

  .step__bar {
    justify-content: space-between;
    position: relative;
    top: -22px;
    max-width: 100%;
    height: 10px;
    background: $dark-blue-20;
    z-index: 1;
    border-radius: 8px;

    .step__bar__progress {
      max-width: 0%;
      height: 10px;
      background: $blue;
      border-radius: inherit;
    }
  }

  .step__content {
    margin-bottom: 40px;
    height: 100%;
    @include tablet {
      height: unset;
    }
  }

  .controls {
    display: flex;
    justify-content: center;
    max-width: 100%;
    margin: 0 16px 26px 16px;

    .controls__action:first-child {
      margin-right: 7px;
    }

    .controls__action:last-child {
      margin-left: 7px;
    }
  }
}
</style>
